<template>
  <div id="app">
    <a-config-provider :locale="zhCN">
      <div v-if="isRouteReady">
        <HeaderTotal
          v-if="
            !showCmsList.includes($route.path) &&
            !$route.path.includes('myself') &&
            $route.path !== '/' &&
            $route.path !== '/login'
          "
        />
        <CmsHeader
          :name="
            $route.path.indexOf('myself') !== -1
              ? (name = '用户中心')
              : (name = '政策服务')
          "
          v-if="
            $route.path.indexOf('myself') !== -1 ||
            $route.path === '/' ||
            showCmsList.includes($route.path)
          "
        />
        <router-view />
        <FooterTatal
          v-if="
            !showCmsList.includes($route.path) &&
            !$route.path.includes('myself') &&
            $route.path !== '/' &&
            $route.path !== '/login'
          "
        />
        <CmsFooter
          v-if="
            showCmsList.includes($route.path) ||
            $route.path === '/' ||
            $route.path.includes('myself')
          "
        />
      </div>
    </a-config-provider>
  </div>
</template>

<script>
import HeaderTotal from "./components/HeaderTotal.vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import FooterTatal from "./components/FooterTatal.vue";
import CmsHeader from "./components/CmsHeader.vue";
import CmsFooter from "./components/CmsFooter.vue";
export default {
  name: "IndexVue",
  components: {
    HeaderTotal,
    FooterTatal,
    CmsHeader,
    CmsFooter,
  },
  data() {
    return {
      zhCN,
      name: "",
      showCmsList: [
        "/policy/policyList",
        "/policy/policyDetail",
        "/policy/policyDetailRead",
        "/policy/enterpriseTest",
        "/policy/enterpriseTestDetail",
        "/policy/policyMatch",
        "/policy",
      ],
      isRouteReady: false,
    };
  },
  created() {
    this.$router.onReady(() => {
      this.isRouteReady = true;
    });
  },
};
</script>
<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */

body {
  margin: 0;
  padding: 0;
}
</style>
